import React from 'react'
import moment from 'moment'
import styled from 'styled-components'

import StateDispatch from './contextInfo'

import {
  Scatter,
  ScatterChart,
  XAxis,
  YAxis,
  Tooltip
} from 'recharts'

const CardRevenueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`

const Title = styled.h1`
  font-size: 1.2em;
  font-weight: 400; 
  line-height: 100%;
  letter-spacing: 0.05em;
  padding-top: 1.2rem;
  margin-bottom: 1rem;
  color: #373D3F;
`

const ScatterChartWrapper = styled.div`
  flex-grow: 1;

  display: flex;
  align-items: center;
`

function convert(time) {
  return moment.unix(time).format('Qo YYYY')
} 

export default function CardRevenue ({ chartData }) {
  const info = React.useContext(StateDispatch)

  const mapRevenue = [];

  for (let i = 0; i < info.length; i = i+10) {
    let curClient = info[i];

    for (let k = 0; k < curClient.orders.length; k++) {
      let nPrice = Number(curClient.orders[k].price.replace(/[^0-9.-]+/g,""))
      let curOrderRevenue = nPrice * curClient.orders[k].days
      const obj = { value: Math.floor(curOrderRevenue), time: `${curClient.orders[k].rentdate}`}
      mapRevenue.push(obj)
    }
  }

  return (
    <CardRevenueWrapper>
      <Title>Revenue</Title>
      <ScatterChartWrapper>
        <ScatterChart
          width={270}
          height={260}
        >
          <XAxis
            dataKey = 'time'
            domain = {['auto', 'auto']}
            name = 'Time'
            tickFormatter = {(unixTime) => moment.unix(unixTime).format('Qo YY')}
            type = 'number'
          />
          <YAxis dataKey="value" name="Value" hide={true} />
          <Tooltip 
            formatter={(value, name, props) => {
              if (name === 'Time') {
                return [convert(value), 'Quarter: ']
              } else {
                return [value, 'Revenue: $']
              }
            }} 
            cursor={{ strokeDasharray: '3 3' }} 
            separator={''}
          />
          <Scatter 
          name = 'Values'
            data={mapRevenue} 
            fill="#4285F4" />
        </ScatterChart>
      </ScatterChartWrapper>
    </CardRevenueWrapper>
    );

}

